import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formTemplatesActions from '../formTemplates/formTemplates.actions';
import FormDrawer from './formDrawer';


function mapStateToProps(state) {
  return {
    isLoading: state.formTemplates.isLoading,
    templates: state.formTemplates.templates,    
    videoConfiguration: state.video.configuration,
    isVideoV2ConfigurationLoaded: state.video.isVideoV2ConfigurationLoaded,
    videoV2Configuration: state.video.videoV2Configuration,
  };
}

function mapActionsToProps(dispatch) {
  return bindActionCreators({    
    ...formTemplatesActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapActionsToProps)(FormDrawer);
